<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="100"
      ref="FormComponent"
      @handleReset="handleReset"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem label="" :label-width="0">
          <RadioGroup
            v-model="formItem.achStage"
            @on-change="achStageOnChange"
            style="display:flex;justify-content: space-between"
          >
            <Radio label="目标设定"
              ><!-- 目标设定 -->{{ $t("Objective_Setting") }}</Radio
            >
            <Radio label="阶段回顾"
              ><!-- 阶段回顾 -->{{ $t("Phase_Review") }}</Radio
            >
            <Radio label="年终总结"
              ><!-- 年终总结 -->{{ $t("End-Year_Review_Over") }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot2">
        <FormItem :label="$t('Performance_Priorities')"
          ><!-- 绩效重点 -->
          <Input v-model="formItem.achKeyNote" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot3">
        <FormItem :label="$t('Detailed_Description')"
          ><!-- 详细描述 -->
          <Input v-model="formItem.details" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot4">
        <FormItem :label="$t('Detailed_Measures')"
          ><!-- 衡量指标 -->
          <Input v-model="formItem.measure" clearable />
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot5">
        <FormItem :label="$t('Start_Date')"
          ><!-- 开始日期 -->
          <DatePicker
            type="daterange"
            :transfer="true"
            v-model="formItem.beginDate"
            style="width:100%"
            clearable
            @on-change="formItem.beginDate = $event"
          ></DatePicker>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot6">
        <FormItem :label="$t('End_Date')"
          ><!-- 结束日期 -->
          <DatePicker
            type="daterange"
            :transfer="true"
            v-model="formItem.afterDate"
            style="width:100%"
            clearable
            @on-change="formItem.afterDate = $event"
          ></DatePicker>
        </FormItem>
      </Col>
      <!-- <Col :xs="24" :sm="24" :md="12" :lg="12" slot="slot7">
                <FormItem :label="$t('Completion_Status')" :labelWidth="120">实际完成情况
                    <Input v-model="formItem.finish" clearable/>
                </FormItem>
            </Col> -->
      <Col :xs="24" :sm="24" :md="24" :lg="12" slot="slot8">
        <FormItem
          :label="$t('Progress_statement_and_follow_up_actions')"
          :labelWidth="180"
          ><!-- 进度说明及后续行动 -->
          <Input v-model="formItem.empDetails" clearable />
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot9"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
    </FormComponent>
    <PerformanceFocusTableA
      ref="PerformanceFocusTableA"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      v-show="nowShow == '目标设定'"
    ></PerformanceFocusTableA>
    <PerformanceFocusTableB
      ref="PerformanceFocusTableB"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      v-show="nowShow == '阶段回顾'"
    ></PerformanceFocusTableB>
    <PerformanceFocusTableC
      ref="PerformanceFocusTableC"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      v-show="nowShow == '年终总结'"
    ></PerformanceFocusTableC>
  </div>
</template>

<script>
import FormComponent from "./FormComponent.vue";
import PerformanceFocusTableA from "./tableComponents/PerformanceFocusTableA.vue";
import PerformanceFocusTableB from "./tableComponents/PerformanceFocusTableB.vue";
import PerformanceFocusTableC from "./tableComponents/PerformanceFocusTableC.vue";
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
export default {
  components: {
    FormComponent,
    PerformanceFocusTableA,
    PerformanceFocusTableB,
    PerformanceFocusTableC
  },
  data() {
    return {
      date: new DateUtil(),
      nowShow: "目标设定",
      formItem: {
        achStage: "目标设定"
      },
      searchItem: {
        achStage: "目标设定"
      },
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      STIProportion: [],
      nowShowVal: "目标设定",
      ManagementLevel: [],
    };
  },
  mounted() {
    // this.getData()
    this.getListData();
    this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
  },
  methods: {
    achStageOnChange(val) {
      this.nowShowVal = val;
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.STIProportion = res.STIProportion;
          this.ManagementLevel = res.ManagementLevel;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.$refs.FormComponent.functionList = res.functionList;
        }
      });
    },
    getData(item) {
      item ? (this.formItem = JSON.parse(item)) : "";
      item ? (this.searchItem = JSON.parse(item)) : "";
      // this.searchItem.startDate?this.searchItem.startDate=this.date.dateVal(this.searchItem.startDate,'YYYY-MM-DD'):''
      // this.searchItem.endDate?this.searchItem.endDate=this.date.dateVal(this.searchItem.endDate,'YYYY-MM-DD'):''
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        ...this.pageInfo
      };
      this.loading = true;
      if (this.formItem.achStage == "目标设定") {
        this.$refs.PerformanceFocusTableA.loading = true;
      } else if (this.formItem.achStage == "阶段回顾") {
        this.$refs.PerformanceFocusTableB.loading = true;
      } else {
        this.$refs.PerformanceFocusTableC.loading = true;
      }
      this.nowShow = this.nowShowVal;
      axios.post("/achReport/selectKeyNoteInfo", obj).then(res => {
        if (res) {
          if (this.formItem.achStage == "目标设定") {
            this.$refs.PerformanceFocusTableA.data = res.data;
            this.$refs.PerformanceFocusTableA.total = parseInt(
              res.pageInfo.total
            );
            this.$refs.PerformanceFocusTableA.spanbFun(res.data);
            this.$refs.PerformanceFocusTableA.tableSpan(res.data);
            this.$refs.PerformanceFocusTableA.loading = true;
            this.$refs.PerformanceFocusTableA.searchItem = this.searchItem;
          } else if (this.formItem.achStage == "阶段回顾") {
            if (res.data.length > 0) {
              this.$refs.PerformanceFocusTableB.data = res.data;
              this.$refs.PerformanceFocusTableB.total = parseInt(
                res.pageInfo.total
              );
              this.$refs.PerformanceFocusTableB.spanbFun(res.data);
              this.$refs.PerformanceFocusTableB.tableSpan(res.data);
              this.$refs.PerformanceFocusTableB.loading = true;
              this.$refs.PerformanceFocusTableB.searchItem = this.searchItem;
            }
          } else {
            this.$refs.PerformanceFocusTableC.data = res.data;
            this.$refs.PerformanceFocusTableC.total = parseInt(
              res.pageInfo.total
            );
            this.$refs.PerformanceFocusTableC.spanbFun(res.data);
            this.$refs.PerformanceFocusTableC.tableSpan(res.data);
            this.$refs.PerformanceFocusTableC.loading = true;
            this.$refs.PerformanceFocusTableC.searchItem = this.searchItem;
          }
        }
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
        this.$refs.PerformanceFocusTableA.loading = false;
        this.$refs.PerformanceFocusTableB.loading = false;
        this.$refs.PerformanceFocusTableC.loading = false;
      });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.$refs.PerformanceFocusTableA.pageInfo.pageNo = 1;
      this.$refs.PerformanceFocusTableB.pageInfo.pageNo = 1;
      this.$refs.PerformanceFocusTableC.pageInfo.pageNo = 1;
      this.getData(item);
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    handleReset() {
      if (this.formItem.achStage == "目标设定") {
        this.formItem = {
          achStage: "目标设定"
        };
      } else if (this.formItem.achStage == "阶段回顾") {
        this.formItem = {
          achStage: "阶段回顾"
        };
      } else {
        this.formItem = {
          achStage: "年终总结"
        };
        this.formItem.achStage = "年终总结";
      }

      this.serialnumber.year = this.date.dateVal(new Date(), "YYYY");
      // this.$refs.PerformanceFocusTableA.pageInfo.pageNo = 1;
      // this.$refs.PerformanceFocusTableB.pageInfo.pageNo = 1;
      // this.$refs.PerformanceFocusTableC.pageInfo.pageNo = 1;
      // this.getData(JSON.stringify(this.formItem))
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PerformanceFocus.vue